import { AddressVerificationButton } from './addressVerificationButton';
import { AddressWithChanges } from './addressWithChanges';

import template from './addressVerificationForm.html';
import './addressVerificationForm.scss';

export const AddressVerificationForm = angular
    .module('checkout.components.addressVerificationForm', [
        AddressWithChanges,
        AddressVerificationButton
    ])
    .component('addressVerificationForm', {
        template,
        bindings: {
            address: '<',
            changes: '<',
            contactInfo: '<',
            loading: '<',
            onChooseAddress: '<',
            recommendations: '<'
        },
        controller: class AddressVerificationFormController {
            constructor() {
                Object.assign(this, {
                    chooseEnteredAddressButtonClicked: false,
                    chooseSuggestedAddressButtonClicked: false
                });
            }

            $onInit() {
                this.verifiedWithChanges = this.changes && Object.keys(this.changes).length;
                this.hasRecommendations = !!this.recommendations;
                this.notVerified = !this.hasRecommendations && !this.verifiedWithChanges;

                // highlight incorrect address parts
                if (this.primaryInfoNeeded() || this.boxRouteNumberNeeded()) {
                    this.changes = {
                        address1: this.address.address1
                    };
                }

                if (this.secondaryInfoNeeded()) {
                    this.changes = {
                        address2: this.address.address2
                    };
                }
            }

            primaryInfoNeeded() {
                const primaryInfoMessages = [
                    'Primary Number Missing',
                    'Primary Number Invalid'
                ];

                return (this.recommendations || [])
                    .some(r => primaryInfoMessages.includes(r));
            }

            secondaryInfoNeeded() {
                const secondaryInfoMessages = [
                    'Missing Secondary Information',
                    'Secondary Information Unrecognized'
                ];

                return (this.recommendations || [])
                    .some(r => secondaryInfoMessages.includes(r));
            }

            boxRouteNumberNeeded() {
                const boxRouteInfoMessages = [
                    'Box/Route Number Missing',
                    'Box/Route Number Invalid'
                ];

                return (this.recommendations || [])
                    .some(r => boxRouteInfoMessages.includes(r));
            }

            chooseEnteredAddress() {
                this.chooseEnteredAddressButtonClicked = true;
                this.onChooseAddress(this.address);
            }

            chooseSuggestedAddress() {
                this.chooseSuggestedAddressButtonClicked = true;
                const suggestedAddress = { ...this.address, ...this.changes };
                this.onChooseAddress(suggestedAddress);
            }

            editAddress() {
                this.onChooseAddress();
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/addressVerificationForm/addressVerificationForm.js